import React from "react";
import styled, { css } from "styled-components";
import GridTableRow from "./gridTableRow";

const modeVariants = {
  mini: {
    table: css`
      font-size: ${({ theme }) => theme.fontSize.lsmall};
      line-height: 1;
    `,
    th: css`
      border-bottom-width: 1px;
      padding: 6px 4px;
      font-weight: 600;
    `,
  },
  normal: {
    table: css`
      font-size: ${({ theme }) => theme.fontSize.normal};
      line-height: 2;
    `,
    th: css`
      border-bottom-width: 2px;
      padding: 8px;
      font-weight: 600;
    `,
  },
};

const StyledGridTable = styled.table`
  width: 100%;
  /* 设置边框合并 */
  border-collapse: collapse;
  border-spacing: 0;
  ${({ mode }) => modeVariants[mode]?.table}
`;

const StyledTh = styled.th`
  border: 1px solid ${({ theme }) => theme.weakGray};
  vertical-align: middle;
  color: ${({ theme }) => theme.black};
  ${({ mode }) => modeVariants[mode]?.th}
  white-space: nowrap;
`;

const StyledGridHead = styled.thead`
  text-align: center;
`;

const StyledGridBody = styled.tbody``;

const GridTable = ({
  auth,
  items = [],
  heads = [],
  paths = [],
  showTools = false,
  tools = [],
  rowCursor,
  rowClick,
  mode = "normal",
}) => {
  return (
    <StyledGridTable mode={mode}>
      <StyledGridHead>
        <tr>
          {heads.map((head, index) => (
            <StyledTh mode={mode} key={index}>
              {head}
            </StyledTh>
          ))}
          {tools && showTools && <StyledTh mode={mode}>Tools</StyledTh>}
        </tr>
      </StyledGridHead>
      <StyledGridBody>
        {items.map((item, index) => (
          <GridTableRow
            key={index}
            mode={mode}
            auth={auth}
            item={item}
            paths={paths}
            tools={tools}
            showTools={showTools}
            cursor={rowCursor}
            onClick={rowClick}
          />
        ))}
      </StyledGridBody>
    </StyledGridTable>
  );
};

export default GridTable;
